'use client';

import { ReactNode } from 'react';
import classNames from 'classnames';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';

import { AutoGrid } from '@preventx/oxygen';

// Services
import { onDropdownHeaderOpen } from '@preventx/prismic-services/src/services/display/dropdown';

type NavigationMultiColumnDropdownProps = {
  label: string;
  children: ReactNode;
};

export const NavigationMultiColumnDropdown = ({
  label,
  children,
}: NavigationMultiColumnDropdownProps) => (
  <Menu as="div" className="dropdown" data-type="mega">
    {({ open }) => {
      if (open) {
        onDropdownHeaderOpen();
      }

      return (
        <>
          <MenuButton className="dropdown__control site-head__link">
            {label}
          </MenuButton>

          <div className={classNames({ 'dropdown__panel active': open })}>
            <MenuItems as="div" className="wrapper" data-size="md">
              <AutoGrid>{children}</AutoGrid>
            </MenuItems>
          </div>

          {!open && (
            <div aria-hidden={true} className="hidden">
              <AutoGrid>{children}</AutoGrid>
            </div>
          )}
        </>
      );
    }}
  </Menu>
);
